//
// Generated class UserDashboardItem
//

/// <reference path="UserDashboardItem_ManagedObject.ts" />

class UserDashboardItem extends UserDashboardItem_ManagedObject
{

}
